import { P00039DataRxTxIndex } from '../../P00039Sync';
import { Pool } from '../../../../../../apis/pool.api';
import { IProduct } from '../../../IProduct';

export function P0003605FunctionReset(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.InjectionChlore_Controle,
    'icCResetUsine',
    1,
    null,
    productClass,
  );
}
